import { useMemo } from 'react';
import useSchoolVariation from './useSchoolVariation';
import adaptVariation from './adaptVariation';

/**
 * Fetch a single variation (by id) for a school and adapt it to the same
 * shape as `useProduct()` so existing PDP components can render it without
 * changes.
 *
 *   - `colors` is sourced from the canonical `color` slug attribute.
 *   - `attributes` is the unified per-slug list. Each entry carries
 *     `{ slug, name, type, values, pinned, pinnedValueIds }` so the UI can
 *     both map by slug and lock pinned values.
 *   - `sizes` mirrors the values of the `size` slug attribute (kept for
 *     backward compatibility with existing PDP code).
 */
export default function useVariation(brandSlug, schoolSlug, variationId, className = null, shopSlug = null) {
  const { school, variation, loading, error } = useSchoolVariation(brandSlug, schoolSlug, variationId, className, shopSlug);

  const data = useMemo(() => adaptVariation(variation), [variation]);

  return {
    data,
    school,
    loading,
    error,
  };
}
